import { useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { AUTO_LOGOUT_TIMEOUT } from '../config';
import { useIdleTimer } from 'react-idle-timer';

const IdleTimerCheck = ({ children }) => {

  const authState = useSelector((state) => state.auth);
  const navigate = useNavigate();
  const idleTimerRef = useRef();

  // Idle timer functions, only used when isLoggedIn == true
  const [idleTimerState, setIdleTimerState] = useState({
    timeout: AUTO_LOGOUT_TIMEOUT,
    showModal: false,
    isTimedOut: false
  })

  const checkLastActivity = () => {
    if (!idleTimerRef.current)
      return;

    const currentTime = new Date().getTime()
    const difference = currentTime - idleTimerRef.current.getLastActiveTime()
    const milliSecondsDifference = difference;
    if (milliSecondsDifference >= AUTO_LOGOUT_TIMEOUT) {
      navigate({ pathname: '/logout' }, { state: { to: 1 } })
    }
  }


  const onActive = (e) => {
    setIdleTimerState({ ...idleTimerState, isTimedOut: false })
    checkLastActivity()
  }

  const onIdle = (e) => {
    const isTimedOut = idleTimerState.isTimedOut
    if (isTimedOut) {
      navigate({ pathname: '/logout' }, { state: { to: 1 } })
    } else {
      setIdleTimerState({ ...idleTimerState, isTimedOut: false })
      setIdleTimerState({ ...idleTimerState, isTimedOut: true })
    }
  }

  const onAction = (e) => { }

  const idleTimer = useIdleTimer({

    onIdle,
    onActive,
    onAction,
    timeout: AUTO_LOGOUT_TIMEOUT,
    promptTimeout: 0,
    events: [
      'mousemove',
      'keydown',
      'wheel',
      'DOMMouseScroll',
      'mousewheel',
      'mousedown',
      'touchstart',
      'touchmove',
      'MSPointerDown',
      'MSPointerMove',
      'visibilitychange'
    ],
    immediateEvents: [],
    debounce: 0,
    throttle: 0,
    eventsThrottle: 200,
    element: document,
    startOnMount: true,
    startManually: true,
    stopOnIdle: false,
    crossTab: true,
    name: 'idle-timer',
    syncTimers: 0,
    leaderElection: false
  })

  if (authState.isLoggedIn)
    idleTimer.start();
  else
    idleTimer.pause();


  return children;
};

export default IdleTimerCheck;